module.exports = __webpack_public_path__ + "static/media/students.25e6160f.png";